<template>
  <div id="company">
    <el-row style="border-bottom: 2px dotted #e7eaec; padding-bottom: 10px">
      <el-col
        :span="20"
        style="font-weight: bold; line-height: 36px; font-size: 22px"
      >
        短信验证码
      </el-col>
      <!--            <el-col :span="4" >-->
      <!--                <el-button type="success" @click.stop="handleAddClick" style="float: right" size="small">-->
      <!--                    <i :class="['iconfont', 'el-icon-plus']" style="position: relative;top:1px"></i>-->
      <!--                    新增-->
      <!--                </el-button>-->
      <!--            </el-col>-->
    </el-row>

    <el-row
      style="margin-top: 20px; border-bottom: 2px dotted rgb(231, 234, 236)"
    >
      <el-row>
        <el-col :span="12">
          <span
            style="
              font-weight: bold;
              display: inline-block;
              width: 70px;
              margin-right: 10px;
            "
          >
            日期</span
          >
          <div style="display: inline-block; width: calc(100% - 120px)">
            <el-date-picker
              v-model="startTime"
              format="yyyy-M-d"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              placeholder="选择日期"
              style="width: 45%"
            >
            </el-date-picker
            ><span style="display: inline-block; width: 10%; text-align: center"
              >至 </span
            ><el-date-picker
              v-model="endTime"
              format="yyyy-M-d"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              placeholder="选择日期"
              style="width: 45%"
            >
            </el-date-picker>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" style="margin-top: 20px">
          <span
            style="
              font-weight: bold;
              display: inline-block;
              width: 70px;
              margin-right: 10px;
            "
          >
            手机号</span
          >
          <el-input
            v-model="phone"
            clearable
            placeholder="请输入手机号"
            style="width: calc(100% - 120px)"
          ></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" style="margin-top: 20px">
          <span
            style="
              font-weight: bold;
              display: inline-block;
              width: 70px;
              margin-right: 10px;
            "
          >
            状态</span
          >

          <el-radio-group
            style="display: inline-block; width: calc(100% - 120px)"
            v-model="radio"
          >
            <el-radio label="VALID">未使用</el-radio>
            <el-radio label="INVALID">已使用</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 20px; margin-top: 84px">
        <el-button type="primary" size="small" @click.stop="getCaptchaList"
          >查询</el-button
        >
        <el-button type="danger" size="small" @click.stop="handleResetClick"
          >重置</el-button
        >
      </el-row>
    </el-row>

    <el-table
      :data="tableData"
      :header-cell-style="{ color: 'black', 'font-size': '15px' }"
      border
      style="width: 100%; margin-top: 20px"
      stripe
    >
      <el-table-column
        fixed
        align="center"
        type="index"
        label="序号"
        width="60"
      >
      </el-table-column>
      <el-table-column min-width="400" prop="username" sortable label="手机号">
      </el-table-column>
      <el-table-column width="200" prop="sent_date" sortable label="发送日期">
        <template slot-scope="scope">
          <span v-if="scope.row.expires">
            {{ scope.row.expires }}
          </span>
          <span v-else> - </span>
        </template>
      </el-table-column>
      <el-table-column min-width="400" prop="captcha" sortable label="验证码">
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        width="80"
        style="color: #3b99f7"
        label-class-name="company_table_cell"
      >
        <template slot-scope="scope">
          <el-button
            size="small"
            style="float: right; background: #ff9901; border: none; color: #fff"
            @click="handleDetail(scope.row)"
            >详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col style="margin-bottom: 20px">
      <pagination :page="page" @changePage="changePageClick"></pagination>
    </el-col>

    <el-dialog
      :visible.sync="dialogVisit"
      width="35%"
      :show-close="false"
      style="vertical-align: center; color: #fff9f3; margin-top: 9vh"
    >
      <div style="height: 350px">
        <el-row style="border-bottom: 2px dotted #e7eaec; padding-bottom: 15px">
          <el-col :span="6">
            <div style="color: #3998f7; font-size: 20px">短信验证码详情</div>
          </el-col>
          <el-col :span="18">
            <div align="right">
              <el-button type="danger" size="small" @click.stop="close">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div id="back" style="margin-top: 20px">
          <el-row>
            <el-col :span="24" style="margin-top: 20px">
              <span
                style="
                  font-weight: bold;
                  display: inline-block;
                  width: 70px;
                  margin-right: 10px;
                "
              >
                手机号</span
              >
              <el-input
                :readonly="true"
                v-model="detail.username"
                clearable
                placeholder=""
                style="width: calc(100% - 120px)"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="margin-top: 20px">
              <span
                style="
                  font-weight: bold;
                  display: inline-block;
                  width: 70px;
                  margin-right: 10px;
                "
              >
                发送日期</span
              >
              <el-date-picker
                :readonly="true"
                v-model="detail.expires"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                clearable
                placeholder=""
                style="width: calc(100% - 120px)"
              >
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="margin-top: 20px">
              <span
                style="
                  font-weight: bold;
                  display: inline-block;
                  width: 70px;
                  margin-right: 10px;
                "
              >
                验证码</span
              >
              <el-input
                :readonly="true"
                v-model="detail.captcha"
                clearable
                placeholder=""
                style="width: calc(100% - 120px)"
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" style="margin-top: 20px">
              <span
                style="
                  font-weight: bold;
                  display: inline-block;
                  width: 70px;
                  margin-right: 10px;
                "
              >
                状态</span
              >

              <el-radio-group
                :disabled="true"
                style="display: inline-block; width: calc(100% - 120px)"
                v-model="detail.status"
              >
                <el-radio label="VALID">未使用</el-radio>
                <el-radio label="INVALID">已使用</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../APIService/http";
import pagination from "../../../components/pagination";
import moment from "moment";

import { quillEditor } from "vue-quill-editor";
// import 'quill/dist/quill.core.css'
import "quill/dist/quill.snow.css";
// import 'quill/dist/quill.bubble.css'
import * as Quill from "quill"; //引入编辑器
// import { ImageDrop } from 'quill-image-drop-module';
// Quill.register('modules/imageDrop', ImageDrop);
// import ImageResize from 'quill-image-resize-module'  //调整大小
// Quill.register('modules/imageResize', ImageResize)  //添加

import http2 from "../../../APIService/http2";
import Video from "./video.js";
Quill.register(Video, true);

export default {
  name: "messageAuthentication",
  data() {
    return {
      detail: {},
      startTime: "",
      endTime: "",
      phone: "",
      dialogVisit: false,
      radio: "",
      tableData: [],
      page: {
        current: 1,
        size: 5,
        total: 0,
      },
    };
  },
  components: {
    pagination,
  },
  created() {
      this.getCaptchaList()
  },
  mounted() {},
  methods: {
    close() {
      this.dialogVisit = false;
    },
    //详情
    handleDetail(item) {
      this.detail = item;
      this.dialogVisit = true;
    },
    // 改变页码信息
    changePageClick(page, size) {
      if (page) {
        this.page.current = page;
      }
      if (size) {
        this.page.size = size;
      }
      this.getCaptchaList();
    },
    async getCaptchaList() {
      let loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let params = {
          tenant_id: user.tenant_id,
          phone: this.phone,
          status: this.radio,
          startTime: this.startTime,
          endTime: this.endTime,
          limit: this.page.size,
          offset: this.page.current - 1,
        };
        if (this.startTime == "" || this.startTime == null) {
          params.startTime = "";
        } else {
          params.startTime = moment(this.startTime).format("YYYY-MM-DD");
        }
        if (this.endTime == "" || this.endTime == null) {
          params.endTime = "";
        } else {
          params.endTime = moment(this.endTime).format("YYYY-MM-DD");
        }

        await http.post("/wapi/v1/getCaptchaList", params).then((res) => {
          debugger
          if (res.success) {
            this.tableData = res.data;
            this.page.total = res.resultCount;
          }
          loading.close();
        });
      } catch (e) {
        loading.close();
        return e;
      }
    },
    handleResetClick() {
      this.startTime = "";
      this.endTime = "";
      this.phone = "";
      this.radio = "";
    },
  },
};
</script>

<style scoped>
#company >>> .el-form-item__label {
  font-weight: bold;
  color: black;
  text-align: left;
}
#company >>> .home_star label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 4px;
}
#company >>> .el-dialog__header {
  padding: 0;
}
#company >>> .company_table_cell {
  color: #2b92fa !important;
}
#company >>> .ql-container {
  height: calc(100% - 137px) !important;
}
#company >>> .ql-editor {
  height: 600px;
}
#company >>> .ql-header {
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/components/messageAuthentication.vue